import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                           from '../../../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridStatusColumnConfig
}                                           from '../../../../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {nameOf}                             from '../../../../../ap-core/utils/ap-name-of';
import {IPpPlanningWizardSelectionGridData} from '../../pp-planning-wizard.types';
import {
  IGridStatus
}                                           from '../../../../../ap-interface/interfaces/ap-grid-status.interface';
import {
  ApDynGridPropertyColumnConfig,
  FilterType
}                                           from '../../../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {map}                                from 'rxjs/operators';
import {MapViewMode}                        from '../../../../../ap-interface';
import {BestScanData}                       from '../../../../../types/scan.types';
import {
  ApDynGridGroupColumnConfig
}                                           from '../../../../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  GetRoundNumericPipeConfig
}                                           from '../../../../../ap-utils/pipes/configs/get-round-numeric.pipe.config';
import {MapViewStore}                       from '../../../../../stores/layout/mapview.store';
import {GetRoundNumericPipe}                from '../../../../../ap-utils';
import {GetRoundNumericService}             from '../../../../../ap-utils/service/get-round-numeric.service';
import {Injectable}                         from '@angular/core';
import ISettings = Data.BaseData.ISettings;
import ILanguage = Data.Language.ILanguage;

@Injectable()
export class SelectionGridColumnsUiProvider {
  constructor(private mapViewStore: MapViewStore,
              private roundNumericService: GetRoundNumericService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public generateGridColumns(settings: ISettings, language: ILanguage): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: `${nameOf<IPpPlanningWizardSelectionGridData>('Status')}.${nameOf<IGridStatus>('state')}`,
        class: `${nameOf<IPpPlanningWizardSelectionGridData>('Status')}.${nameOf<IGridStatus>('class')}`,
        description: `${nameOf<IPpPlanningWizardSelectionGridData>('Status')}.${nameOf<IGridStatus>('description')}`,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: nameOf<IPpPlanningWizardSelectionGridData>('Nr'),
        width: 60,
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini_Subnumber',
        field: nameOf<IPpPlanningWizardSelectionGridData>('TNr'),
        width: 60,
        hide: true,
        filterable: true,
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: nameOf<IPpPlanningWizardSelectionGridData>('NrTNr'),
        width: 70,
        filterable: true,
        headerFilterable: true,
        hide: new ApDynGridColumnHideConfig({
          selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mode) => mode === MapViewMode.HIDE))
        })
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Name',
        field: nameOf<IPpPlanningWizardSelectionGridData>('Name'),
        width: 150,
        filterable: true,
        sortIndex: 0,
        headerFilterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Area',
        field: nameOf<IPpPlanningWizardSelectionGridData>('Area'),
        width: 100,
        filterable: true,
        headerFilterable: true,
        filterType: FilterType.NUMBER,
        cssClass: 'right',
        tooltip: (dataItem) => this.areaTooltip(dataItem),
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [settings.DigitsAfterDecimalPoint]
        }]
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Crop',
        field: nameOf<IPpPlanningWizardSelectionGridData>('Crop'),
        width: 80,
        filterable: true,
        headerFilterable: true,
        groupIndex: 0,
        groupDesc: true
      }),
      new ApDynGridStatusColumnConfig({
        field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('state')}`,
        class: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('class')}`,
        description: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('Status')}.${nameOf<IGridStatus>('description')}`,
        filterable: true
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Global__latest_Sensor_reading',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            title: 'Global__EC',
            field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('Ec')}`,
            cssClass: 'right',
            filterType: FilterType.NUMBER,
            width: 50,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Date',
            field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('Created')}`,
            format: language.DateFormat,
            width: 70,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__AvgShort',
            field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('NUptakeAvg')}`,
            width: 60,
            cssClass: 'right',
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [settings.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }],
            filterType: FilterType.NUMBER,
            filterable: true
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Min',
            field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('NUptakeMin')}`,
            width: 60,
            filterable: true,
            cssClass: 'right',
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [settings.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }],
            filterType: FilterType.NUMBER,
          }),
          new ApDynGridPropertyColumnConfig({
            title: 'Global__Max',
            field: `${nameOf<IPpPlanningWizardSelectionGridData>('ScanData')}.${nameOf<BestScanData>('NUptakeMax')}`,
            width: 60,
            filterable: true,
            cssClass: 'right',
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [settings.DigitsAfterDecimalPoint, GetRoundNumericPipeConfig.NullToEmptyReplaceConfig]
            }],
            filterType: FilterType.NUMBER,
          }),
        ]
      })
    ];
  }

  /**
   * Generates a tooltip for field area
   * @param dataItem The grid data item
   * @returns Formatted area string or undefined if no area
   * @private
   */
  private areaTooltip(dataItem: IPpPlanningWizardSelectionGridData): string | undefined {
    if (dataItem.Area) {
      return this.roundNumericService.stringify(dataItem.Area, 4);
    }
    return undefined;
  }
}
